import { fromJS } from 'immutable'
import * as types from './action-types'

const InitialState = fromJS({
  title: 'Artists',
  fetching: false,
  data: null,
  enabled: true
})

export default (state = InitialState, action) => {
    switch (action.type) {
      case types.SET_ARTISTS_ENABLED:
        return state
          .set('enabled', action.payload)
      case types.REQUEST_ARTISTS:
        return state
          .set('fetching', true)
          .set('data', null)

      case types.RECEIVE_ARTISTS:
        return state
          .set('fetching', false)
          .set('data', fromJS(action.payload.data.message))

      case types.ERROR_ARTISTS:
        return state 
          .set('fetching', false)
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/components/artist-list-container/reducer.js